import React, { useState, useEffect } from 'react';

/** Form validation */
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import usePostAxiosData from 'hooks/usePostAxiosData';
import useAppQuery from 'hooks/useAppQuery';
import toast from 'react-hot-toast';
import InputField from 'components/fields/InputField';
import Error from 'components/message/Error';
import { config } from 'variables/config';
import MuiSelect from 'components/MuiSelect';
import MuiDatePicker from 'components/MuiDatePicker';
import { AppBar, Dialog, DialogContent, Toolbar, Typography } from '@mui/material';
import MButton from 'components/Mbutton';
import { CloseModalButton } from 'components/Utils';
import { useTranslation } from 'react-i18next'; // Importer useTranslation

const AddMission = (props) => {
  const { isOpen, onClose } = props;
  const { t } = useTranslation('add_mission'); // Utiliser le namespace 'addMission'

  /** Form validation config */
  const schema = yup.object().shape({
    participants: yup.string().required(t('participants_required')), // Traduit
    description: yup.string(),
  });

  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);
  const [region, setRegion] = useState(null);
  const [departement, setDepartement] = useState(null);
  const [regionId, setRegionId] = useState(null);

  const { data: regions } = useAppQuery(`${config.app.api_url}/regions`);

  const { data: departments } = useAppQuery(
    `${config.app.api_url}/regions/${regionId !== '*' && regionId}/departments`
  );

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  console.log('🚀 ~ AddMission ~ errors:', errors);
  const onSubmitHandler = (data) => {
    handleSave(data);
  };

  /** post create user */
  const [loading, postAxiosData, errorMassage, successMessage, result] = usePostAxiosData(
    `missions`,
    'POST'
  );

  const handleSave = async (dataYub) => {
    const data = {
      ...dataYub,
      participants: dataYub?.participants?.split(','),
      regionId,
      start,
      end,
    };
    console.log('🚀 ~ handleSave ~ data:', data);
    await postAxiosData(data);
  };

  /** gestion des erreurs et succès */
  useEffect(() => {
    if (successMessage?.status === 200 || successMessage?.status === 201) {
      reset();
      toast.success(
        `${
          successMessage?.message != null ? successMessage?.message : t('success_message') // Traduit
        }`,
        {
          duration: 4000,
          className: 'bg-success text-white',
        }
      );
      props?.endFetch();
      onClose();
    }
  }, [successMessage, reset, props, onClose, t]); // Ajouter 't' aux dépendances

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth={'md'}
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar className="bg-gray-50">
            <Typography
              sx={{ ml: 2, flex: 1 }}
              color={'green'}
              fontWeight={'bold'}
              variant="h6"
              component="div"
            >
              {t('add_mission_title')} {/* Traduit */}
            </Typography>
            <CloseModalButton iconColor={'red'} handleClose={onClose} />
          </Toolbar>
        </AppBar>

        <DialogContent dividers>
          <form onSubmit={handleSubmit(onSubmitHandler)}>
            <div className="my-4 grid gap-2 md:grid-cols-1">
              {errorMassage?.message && (
                <Error message={errorMassage?.message !== '' && errorMassage?.message} />
              )}

              <MuiSelect
                label={t('region_label')}
                value={regionId}
                options={regions?.data}
                format={{ value: 'id', label: 'name' }}
                onChange={(event) => {
                  setRegionId(event.target.value);
                }}
                emptyLabel={t('none_option')}
              />
              <MuiSelect
                label={t('department_label')}
                value={departement}
                options={departments?.data}
                format={{ value: 'id', label: 'name' }}
                onChange={(event) => {
                  setDepartement(event.target.value);
                }}
                emptyLabel={t('none_option')}
              />
              <InputField
                register={register}
                variant="auth"
                extra="mb-3"
                label={t('description_label')}
                required={true}
                placeholder={t('description_placeholder')}
                id="description"
                name="description"
                type="text"
                error={errors.description?.message !== '' ? errors.description?.message : ''}
              />
              <div className="flex gap-2">
                <MuiDatePicker
                  label={t('start_date_label')}
                  value={start}
                  onChange={(newValue) => {
                    setStart(new Date(newValue));
                  }}
                  wrapperClasses={'flex-1 filter-item anime slideLeft'}
                />
                <MuiDatePicker
                  label={t('end_date_label')}
                  value={end}
                  onChange={(newValue) => {
                    setEnd(new Date(newValue));
                  }}
                  wrapperClasses={'flex-1 filter-item anime slideLeft'}
                />
              </div>
              <InputField
                register={register}
                variant="auth"
                extra="mb-3"
                label={t('participants_label')}
                required={true}
                placeholder={t('participants_placeholder')}
                id="participants"
                name="participants"
                type="text"
                multiline={true}
                error={errors.participants?.message !== '' ? errors.participants?.message : ''}
              />
            </div>
            <div className="flex justify-between p-4">
              <div>
                <MButton
                  variant={'danger'}
                  onClick={(e) => {
                    e?.stopPropagation();
                    e?.preventDefault();
                    onClose();
                  }}
                >
                  {t('close_button')} {/* Traduit */}
                </MButton>
              </div>
              <div>
                <MButton variant={'primary'} type="submit" colorScheme="green">
                  {t('add_button')} {/* Traduit */}
                </MButton>
              </div>
            </div>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AddMission;
